import { render } from "./OrganizationAdd.vue?vue&type=template&id=513b0c57"
import script from "./OrganizationAdd.vue?vue&type=script&lang=js"
export * from "./OrganizationAdd.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__